import React from 'react';
import { motion } from 'framer-motion';
// Reduced floating bills configuration (from 20 to 8)
const billImages = ['https://cdn.magicpatterns.com/uploads/2hQh3nyJJrMGQyGUPZtBE2/bill1.webp', 'https://cdn.magicpatterns.com/uploads/jwWhT8HJvmgg6RTHjiPy4s/bill2.webp', 'https://cdn.magicpatterns.com/uploads/atpt3juckc6FFKVEnrE5md/bill3.webp'];
const floatingBills = Array.from({
  length: 8
}).map((_, i) => ({
  id: i,
  x: Math.random() * 100,
  delay: Math.random() * 5,
  duration: Math.random() * 10 + 15,
  scale: Math.random() * 0.3 + 0.5,
  rotation: Math.random() * 360,
  image: billImages[Math.floor(Math.random() * billImages.length)]
}));
export function HeroSection() {
  return <section className="relative w-full h-screen flex flex-col items-center justify-center overflow-hidden bg-[#0f0f1a]" data-id="element-68">
      {/* Background Image - People/Crowd */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/2zt74ffkVzNVUk6A2PoxWj/people.webp')"
    }} data-id="element-69" />

      {/* Gradient Overlay - Purple to Blue */}
      <div className="absolute inset-0 z-1 bg-gradient-to-r from-[#7b2cbf]/40 via-[#1e3a5f]/30 to-[#00d4ff]/20 mix-blend-overlay pointer-events-none" data-id="element-70" />

      {/* Darker overlay for text readability */}
      <div className="absolute inset-0 z-1 bg-black/30 pointer-events-none" data-id="element-71" />

      {/* Floating Money Animation Layer - Reduced */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none z-10" data-id="element-72">
        {floatingBills.map(bill => <motion.img key={bill.id} src={bill.image} alt="Floating Money" initial={{
        y: '110vh',
        x: `${bill.x}vw`,
        opacity: 0,
        rotate: bill.rotation
      }} animate={{
        y: '-20vh',
        opacity: [0, 0.8, 0.8, 0],
        rotate: bill.rotation + 360
      }} transition={{
        duration: bill.duration,
        repeat: Infinity,
        ease: 'linear',
        delay: bill.delay
      }} className="absolute w-24 md:w-36 object-contain" style={{
        scale: bill.scale
      }} data-id="element-73" />)}
      </div>

      {/* Main Content */}
      <div className="relative z-20 flex flex-col items-center justify-center w-full max-w-7xl mx-auto px-4 h-full pt-20" data-id="element-74">
        {/* Top "Prime Original" Label */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5,
        duration: 0.8
      }} className="absolute top-[15%] flex flex-col items-center z-50" data-id="element-75">
          <span className="text-white font-bold text-lg md:text-xl tracking-wide drop-shadow-md font-sans" data-id="element-76">
            prime original
          </span>
          {/* Amazon Smile SVG */}
          <svg viewBox="0 0 100 20" className="w-20 h-6 mt-1" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-77">
            <path d="M10 5 C 30 18, 70 18, 90 5" stroke="#00A8E1" strokeWidth="3" strokeLinecap="round" data-id="element-78" />
            <path d="M88 8 L90 5 L85 3" fill="#00A8E1" stroke="#00A8E1" strokeWidth="1" data-id="element-79" />
          </svg>
        </motion.div>

        {/* Composite Hero Image Area - Centered */}
        <div className="relative w-full max-w-5xl flex justify-center items-end mt-10 h-[65vh]" data-id="element-80">
          {/* Jimmy Image - Centered, Behind money */}
          <motion.img initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.1
        }} src="https://cdn.magicpatterns.com/uploads/qYNUdzcVRConrBtxvHYFNX/jimmy.webp" alt="Jimmy Beast" className="absolute left-0 right-0 mx-auto bottom-0 h-[85%] md:h-[100%] w-auto object-contain z-10" data-id="element-81" />

          {/* Money Piles - Centered, In front of Jimmy with locomotion animation */}
          <motion.img initial={{
          opacity: 0,
          y: 50
        }} animate={{
          opacity: 1,
          y: [0, -8, 0, -4, 0],
          x: [0, 5, 0, -5, 0]
        }} transition={{
          opacity: {
            duration: 0.8,
            delay: 0.3
          },
          y: {
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut'
          },
          x: {
            duration: 8,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} src="https://cdn.magicpatterns.com/uploads/1FDHQzU5tciPkZxWLKtbYv/money.webp" alt="Money Piles" className="absolute left-0 right-0 mx-auto bottom-[-5%] w-[90%] max-w-5xl object-contain z-20" data-id="element-82" />

          {/* Main Logo Image - Front and Centered */}
          <motion.div initial={{
          scale: 0.8,
          opacity: 0,
          y: 20
        }} animate={{
          scale: 1,
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.4
        }} className="absolute left-0 right-0 mx-auto top-[5%] z-30 w-full flex justify-center items-center" data-id="element-83">
            <img src="https://cdn.magicpatterns.com/uploads/ruWF1esChvHQwkQhbeyWbq/logo.webp" alt="Beast Games - Strong Smart - Prime" className="w-full max-w-md md:max-w-2xl lg:max-w-3xl h-auto object-contain drop-shadow-2xl" data-id="element-84" />
          </motion.div>
        </div>
      </div>
    </section>;
}